export const WEEBLY_LOGIN = 'API_WEEBLY_LOGIN';
export const WEEBLY_LOGIN_SUCCEEDED = 'API_WEEBLY_LOGIN_SUCCEEDED';
export const WEEBLY_LOGIN_FAILED = 'API_WEEBLY_LOGIN_FAILED';

export const WEEBLY_SYNC = 'API_WEEBLY_SYNC';
export const WEEBLY_SYNC_SUCCEEDED = 'API_WEEBLY_SYNC_SUCCEEDED';
export const WEEBLY_SYNC_FAILED = 'API_WEEBLY_SYNC_FAILED';
